import { Flex } from '../../flex/flex';

export const Footer = () => (
  <Flex as="footer" justify="end">
    <small>Copyright &copy; {new Date().getFullYear()}, ENKODE.IO</small>
  </Flex>
);
